import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const upguard = defineConnector({
  identifier: "upguard",
  name: "UpGuard",
  tagLine: "Third-party risk management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://cyber-risk\\.upguard\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In UpGuard, go to **Settings → API** and generate a new API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://cyber-risk.upguard.com/api/public/available_risks",
  },
});
